"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typestyle_1 = require("typestyle");

exports.container = typestyle_1.style({
  width: "150px"
}, {
  height: "200px"
}, {
  background: "#eeeeee"
}, {
  padding: "10px"
}, {
  borderRadius: "10px"
}, {
  marginBottom: "6px"
}, {
  cursor: "pointer"
});
exports.content = typestyle_1.style({
  width: "100%"
}, {
  height: "100%"
}, {
  background: "White"
}, {
  display: "flex"
}, {
  flexDirection: "column"
}, {
  justifyContent: "space-evenly"
}, {
  alignItems: "center"
}, {
  border: "1px solid #d7d7d7"
});
exports.innerContent = typestyle_1.style({
  display: "flex"
}, {
  alignItems: "center"
}, {
  flexDirection: "column"
});
exports.titleStyle = typestyle_1.style({
  fontSize: "15px"
}, {
  color: "#555555"
}, {
  textTransform: "uppercase"
}, {
  marginTop: "16px"
});
exports.subTitleStyle = typestyle_1.style({
  fontSize: "13px"
}, {
  color: "#777777"
});